module.exports = __webpack_public_path__ + "static/media/icon-conference.8b56d50e.svg";